<template>
	<div class="item-row" :class="{ hovered: hover }" @click="clicked">
		<span class="item" :style="style"
			@mouseover="hover = true"
			@mouseleave="hover = false">
			<v-row no-gutters>
				<v-col class="marker start shrink" v-if="!item.startOut">
					<v-icon>fas fa-plus</v-icon>
				</v-col>
				<v-col class="marker start fade shrink" v-else >
					<v-icon>fas fa-arrow-alt-left</v-icon>
				</v-col>
				<v-col class="mid-line grow"><div></div></v-col>
				<v-col class="marker end shrink" :class="item.status" v-if="item.status !== 'start' && !item.endOut">
					<v-icon v-if="item.status  === 'end'">fas fa-check</v-icon>
					<v-icon v-if="item.status  === 'failed'">fas fa-times</v-icon>
					<v-icon v-if="item.status  === 'processing'">fa-spin fas fa-spinner</v-icon>
					<v-icon v-if="item.status  === 'unknown'">fas fa-question</v-icon>
				</v-col>
				<v-col class="marker end fade shrink" :class="item.status" v-if="item.status !== 'start' && item.endOut">
					<v-icon>fas fa-arrow-alt-right</v-icon>
				</v-col>
			</v-row>
		</span>
		<span class="dq-marker" :style="dqStyle" v-if="item.dqLeft && !item.dqOut"
			@mouseover="hover = true"
			@mouseleave="hover = false"
			@click="clicked">
			<v-icon>fas fa-play</v-icon>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		item: Object,
	},
	data() {
		return {
			hover: false,
		};
	},
	computed: {
		style() {
			return `left: ${this.item.left}%; width: ${this.item.width}%`;
		},
		dqStyle() {
			return this.item.dqLeft ? `left: ${this.item.dqLeft}%` : "";
		},
	},
	methods: {
		clicked() {
			this.$emit("click", this.item.id);
		},
	},
};
</script>
